// extracted by mini-css-extract-plugin
module.exports = {"header":"Copyright_header__1AeVw","container":"Copyright_container__3NMuL"};